export default {
  title: {
    en: 'Unpause',
  },
}
